// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Counterparty } from './counterparty';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class IndustryType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  industryTypeId!: number;
  code?: string;
  createdBy!: string;
  createdDate!: Date;
  description!: string;
  locationId!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  counterparties!: Counterparty[];
}

